import { CmsImage } from '@cms/components/cmsImage/CmsImage'
import { RichText } from '@cms/components/richText'
import Headline from '@cms/grid/components/headline'
import { Button } from '@vista-digital/occ-ui'
import type GlobalPopup from '../models'

const buttonClass = 'global-popup-cta btn btn--primary btn--full-width'

const getHeading = (enabledPopup?: GlobalPopup): JSX.Element => (
    <>{enabledPopup?.title && <Headline value={enabledPopup.title} />}</>
)
const getDescription = (enabledPopup?: GlobalPopup): JSX.Element => (
    <>
        {enabledPopup?.description && (
            <RichText classOverride="global-popup-description" htmlText={enabledPopup.description} />
        )}
    </>
)
const getChildren = (enabledPopup?: GlobalPopup): JSX.Element => (
    <>
        {getHeading(enabledPopup)}
        {getDescription(enabledPopup)}
    </>
)
const getFooter = (onButtonClick: () => void, enabledPopup?: GlobalPopup): JSX.Element => (
    <>
        {enabledPopup?.button && (
            <Button className={buttonClass} label={enabledPopup.button.name} onClick={onButtonClick} />
        )}
    </>
)
const getHeader = (enabledPopup?: GlobalPopup): JSX.Element => (
    <>{enabledPopup?.headerImage && <CmsImage image={enabledPopup?.headerImage} />}</>
)

export const getPropsElements = (onButtonClick: () => void, enabledPopup?: GlobalPopup) => {
    return {
        children: getChildren(enabledPopup),
        footer: getFooter(onButtonClick, enabledPopup),
        header: getHeader(enabledPopup),
    }
}

export default getPropsElements
